import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { withSnackbar } from "notistack"

import getErrorText from "../../../../../../library/constants/errorTypes"
import * as routes from "../../../../../../library/constants/routes"
import Button from "@material-ui/core/Button/Button"
import {
  finishKnowmix,
  getKnowmix,
} from "../../../../../../library/store/actions/creators/knowmixCreators"
import "./knowmix-settings-public.scss"
import withErrorBoundary from "../../../../../../hocs/guards/withErrorBoundary"

const KnowmixSettingsPublic = (props) => {
  const { currentKnowmix } = props.knowmix
  const createProduct = () => {
    const { id, name, subjects, grades, creator_group } = currentKnowmix
    props.history.push(routes.MARKETPLACE, {
      id,
      name,
      group: creator_group,
      subjects,
      grades,
      contentType: 15,
      open: true,
    })
  }

  const publishKnowMix = async () => {
    try {
      await props.finishKnowmix({ id: currentKnowmix.id })
      await props.getKnowmix({ id: currentKnowmix.id })
    } catch ({ error }) {
      props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  return (
    <div className="box">
      <div className="box__heading">Release</div>

      <div className="public-container">
        {!currentKnowmix.is_finished ? (
          <>
            <p className={"mb15"}>
              Click Finish to release this course to your Members including the
              Teacher. Finishing this course means you can edit it later on its
              dedicated page under your courses in your Group.
            </p>
            <div className="public-container__button-container">
              <div className={"text-center"}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={publishKnowMix}
                  disabled={!props.knowmix.stepsList.length}
                >
                  RELEASE
                </Button>
                {!props.knowmix.stepsList.length && (
                  <p className={"color-black-38 mt5"}>
                    Course must have at least one step created
                  </p>
                )}
              </div>
            </div>
          </>
        ) : (
          <>
            <p className="mb15 text-center">This course is already released.</p>

            <div className="public-container__button-container">
              <Button
                color="primary"
                variant="contained"
                onClick={publishKnowMix}
                // disabled={!props.knowmix.stepsList.length}
              >
                UNRELEASE
              </Button>
            </div>
          </>
        )}
      </div>

      {/*{!currentKnowmix.is_finished ? (*/}
      {/*  <div className="public-container">*/}
      {/*    <p className="public-container__text">*/}
      {/*      Click Finish to package this Knowmix into a Product or Kourse -*/}
      {/*      essentially these are the same forms that make an item viewable in*/}
      {/*      the public Marketplace or in your Products attached to a Group. This*/}
      {/*      means you will have additional fields like pricing, images and*/}
      {/*      contact information to put in so you can be reached to purchase or*/}
      {/*      open a free product to access if you have a closed Group. Finishing*/}
      {/*      this KnowMix means you can edit it later on its dedicated page under*/}
      {/*      your Products in your Group as well as edit the Product/Kourse info*/}
      {/*      pages.*/}
      {/*    </p>*/}
      {/*    <div className="public-container__button-container">*/}
      {/*      <Button*/}
      {/*        color="primary"*/}
      {/*        variant="contained"*/}
      {/*        onClick={publishKnowMix}*/}
      {/*        disabled={!props.knowmix.stepsList.length}*/}
      {/*      >*/}
      {/*        Finish*/}
      {/*      </Button>*/}
      {/*    </div>*/}
      {/*    {!props.knowmix.stepsList.length && (*/}
      {/*      <div className="f jcc">*/}
      {/*        <FormHelperText error={!props.knowmix.stepsList.length}>*/}
      {/*          KnowMix must contain at least 1 step*/}
      {/*        </FormHelperText>*/}
      {/*      </div>*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*) : !currentKnowmix.product ? (*/}
      {/*  <div className="public-container">*/}
      {/*    <p className="public-container__text">*/}
      {/*      To make KnowMix public you need to create a product. To replace*/}
      {/*      product you will have to delete the entire product and make a new*/}
      {/*      one with new KnowMix. This will not delete other users who have*/}
      {/*      already adopted the first product.*/}
      {/*    </p>*/}
      {/*    <div className="public-container__button-container">*/}
      {/*      <Button color="primary" variant="contained" onClick={createProduct}>*/}
      {/*        Create product ad tile*/}
      {/*      </Button>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*) : (*/}
      {/*  <div className="public-container">*/}
      {/*    <p className="public-container__text">*/}
      {/*      This KnowMix is public and is in marketplace. If you want to make it*/}
      {/*      non-public, you need to remove the product with this KnowMix from*/}
      {/*      marketplace.*/}
      {/*    </p>*/}
      {/*    <div className="public-container__button-container">*/}
      {/*      <Button*/}
      {/*        color="primary"*/}
      {/*        variant="contained"*/}
      {/*        component={Link}*/}
      {/*        to={generatePath(routes.PRODUCT, {*/}
      {/*          productId: currentKnowmix.product.id,*/}
      {/*        })}*/}
      {/*      >*/}
      {/*        Go To Product*/}
      {/*      </Button>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  )
}

const mapState = ({ knowmix }) => ({ knowmix })
const mapDispatch = (dispatch) =>
  bindActionCreators({ finishKnowmix, getKnowmix }, dispatch)

export default connect(
  mapState,
  mapDispatch
)(withSnackbar(withErrorBoundary(KnowmixSettingsPublic)))
